module.exports = __webpack_public_path__ + "static/media/calendarday.3ba3df4b.svg";